<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">IO SONO</a></span></li>
            <li class="last"><span><a href="/sirang/acque">IMPRESA</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout" id="aui_3_4_0_1_591">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H7pGyMq5rlnM_">
                     <span id="p_56_INSTANCE_H7pGyMq5rlnM"></span> 
                     <div class="portlet-body" id="aui_3_4_0_1_590">
                        <section class="portlet" id="portlet_56_INSTANCE_H7pGyMq5rlnM">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Impresa</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content" id="aui_3_4_0_1_589">
                              <div class=" portlet-content-container" style="" id="aui_3_4_0_1_588">
                                 <div class="portlet-body" id="aui_3_4_0_1_587">
                                    <div class="journal-content-article" id="aui_3_4_0_1_586">
                                       <p>
                                          I Servizi Online per le Imprese, che possono accedere al sistema attraverso il proprio rappresentante legale o un soggetto delegato tramite l’utilizzo di credenziali SPID o tessera sanitaria CNS, sono di seguito descritti.
                                       </p>
                                       <p>
                                          L'impresa può presentare una nuova istanza per uno specifico procedimento di interesse ambientale e seguire lo stato di avanzamento delle pratiche già presentate sul Modulo GPA (Gestore dei procedimenti amministrativi). Ad esempio, è possibile presentare una dichiarazione relativa ad un impianto termico o ad un apparecchio PCB oppure procedere alla richiesta di autorizzazione per un impianto di gestione rifiuti. Sono previste, nelle varie fasi del procedimento, le notifiche relative all’avanzamento dell’iter dello stesso. Prima di poter procedere alla presentazione di una richiesta, l’impresa, nel caso in cui non lo sia già, deve comunque essere censita nel sistema, tale operazione deve essere eseguita accedendo alla sezione Gestione utenza-Qualificazione utente.
                                       </p>
                                       <p>
                                          Accedendo al sistema SIRA, inoltre, il rappresentante legale o un suo delegato può fruire dei dati relativi agli oggetti di competenza ambientale propri e ai dati di contesto ambientale pubblici. L'accesso diretto a tale bagaglio di conoscenza ha come effetto principale quello di diffondere la conoscenza ambientale e semplificare i procedimenti. <br>Sono, infine, a disposizione i servizi di relazione digitale con gli uffici del SIRA (numero di telefono dedicato, email).
                                       </p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_RxuFFVEU5ofT_">
                     <span id="p_56_INSTANCE_RxuFFVEU5ofT"></span> 
                     <div class="portlet-body">
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>